import { getProxycadorHost } from "src/features/finance/redeems/imports/environment";
import { fetch } from "src/features/finance/redeems/imports/utils";
import { RedeemConfigResponse } from "src/features/finance/redeems/root/type";

export const loadRedeemConfig = (params: {
  accountId: number;
}): Promise<RedeemConfigResponse> =>
  fetch(`${getProxycadorHost()}/redeemProvider/v2/redeem/config`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "X-TangoAuth-AccountId": `${params.accountId}`,
    },
  }).then((resp) => resp.json());
